import Project from '@/models/Project';
import Product, { ProductActivity } from './Product';

export class PurchaseLine {
    public description: string = null;
    public amount: number | string = 1;
    public price: number = null;
    public inclPrice: number = null;
    public products: Product[] = [];
    public product: Product = null;
    public productId: number = null;
    public department: any = null;
    public departmentObj: any = null;
    public project: any = null;
    public projectObj: Project = null;
    public open: boolean = false;
    public responsible: boolean = false;
    public taxRate: any = null;
    public taxRateId: string = '';
    public attachmentId: string;
    public lineNumber: number = null;
    public budget: any = { available: true, visible: false, text: '' };
    public matched: boolean = false;
    public connectedActivity: string | ProductActivity = null;

    public metaData: MetaData[] = [];
    public projects: Project[] = [];

    constructor(obj?: Partial<PurchaseLine>) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}

// tslint:disable max-classes-per-file
export class MetaData {
    public amount: number = 0;
    public footPrintTypeId: number;
    public label: string;
    public name: string;
}
